app.controller("StudentDocsCreateController", [
    "$scope", "DocumentsService", "$uibModalInstance", "usSpinnerService", "toastr", "AuthService", "$http", "params", "StaticData",
    function ($scope, DocumentsService, $uibModalInstance, usSpinnerService, toastr, AuthService, $http, params, StaticData) {
        $scope.attachments = [];
        $scope.docTypes = [];
        $scope.profiles = [];
        $scope.profilesForDocs = [];
        $scope.docs = [];
        $scope.doc = {
            type: null,
            text: null,
            phone: null,
            email: null,
            invoiceRequired: false,
            studentProfileId: null,
            copiesNumber: 1
        };
        $scope.mode = params.mode;
        $scope.disabled = false;
        DocumentsService.studentDocTypes().then(data => {
            $scope.docTypes = data;
            if (params.mode === 'show') {
                $scope.setTypeFromDocument();
            }
        }, err => {
            toastr.error('', 'დოკუმენტის ტიპების ჩატვირთვისას დაფიქსირდა შეცდომა');
            console.log(err);
        });

        $scope.modalTitle = params.mode === 'show' ? 'განცხადების ნახვა' : 'ახალი განცხადება';
        if (params.mode === 'show') {
            $scope.doc.text = params.doc.text;
        }

        $scope.tinymceOptions = {
            menubar: '',
            toolbar: 'undo redo | underline bold italic | alignleft aligncenter alignright',
            height: "400",
            readonly: params.mode === 'show'
        };

        $scope.setTypeFromDocument = function () {
            for (let i = 0; i < $scope.docTypes.length; i++) {
                if ($scope.docTypes[i]._id === params.doc.type._id) {
                    $scope.doc.type = $scope.docTypes[i];
                    return;
                }
            }
        };

        $scope.typeChanged = function () {
            if (params.mode === 'create' && $scope.doc.type) {
                $scope.doc.text = $scope.doc.type.defaultText;
            }
        };

        $scope.send = function () {
            $scope.disabled = true;
            usSpinnerService.spin('root');
            if (!$scope.doc.type) return;

            if ($scope.doc.type.attachmentRequired && $scope.attachments.length === 0) {
                toastr.error('', 'გთხოვთ, მიაბათ ფაილი');
                $scope.disabled = false;
                return;
            }

            if (!$scope.doc.studentProfileId) {
                if (!$scope.profiles || !$scope.profiles.length) {
                    toastr.error('', 'სტუდენტის პროფილი არ მოიძებნა');
                    $scope.disabled = false;
                    return;
                } else {
                    toastr.error('', 'გთხოვთ აირჩიოთ პროფილი');
                    $scope.disabled = false;
                    return;
                }
            }

            var data = {
                addressees: [],
                attachments: $scope.attachments,
                type: $scope.doc.type._id,
                text: $scope.doc.text,
                phone: $scope.doc.phone,
                email: $scope.doc.email,
                invoiceRequired: $scope.doc.invoiceRequired,
                studentProfileId: $scope.doc.studentProfileId
            };

            if($scope.doc.type.parentId === 'STUDENT_INNER') {
                data.copiesNumber = $scope.doc.copiesNumber;
                data.englishVersion = $scope.doc.englishVersion;
                data.liveSignature = $scope.doc.liveSignature;
                data.takeOut = $scope.doc.takeOut;
                data.sendToMail = $scope.doc.sendToMail;
            }

            // noinspection JSUnusedLocalSymbols
            DocumentsService.studentSent(data).then(function (data) {
                usSpinnerService.stop('root');
                toastr.success("განცხადება წარმატებით გაიგზავნა");
                $scope.disabled = false;
                $uibModalInstance.close();
            }, function (error) {
                if(error.data === "OPEN_DOCUMENTS_EXISTS") {
                    toastr.warning("განცხადება უკვე გაგზავნილია");
                } else {
                    toastr.warning("ხარვეზი განცხადების გაგზავნისას");
                }
                usSpinnerService.stop('root');
                $scope.disabled = false;
            });
        };

        $scope.close = function () {
            $uibModalInstance.dismiss();
        };

        AuthService.getUserData().then(function (data) {
            $scope.doc.phone = data.phone;
            $scope.doc.email = data.email;
            $scope.profiles = data.profiles.filter(function (pr) { return pr.type === 'student' });
            $scope.profilesForDocs = data.profiles.filter(function (pr) { return pr.type === 'student' && (pr.state === 'active' || pr.state === 'pause' || pr.state === 'end') });
            if ($scope.profiles.length === 1)
                $scope.doc.studentProfileId = $scope.profiles[0]._id;
        });

        $scope.uploadAttachment = function (type, files) {
            usSpinnerService.spin("root");
            $scope.file = files[0];
            var fd = new FormData();
            if ($scope.file && $scope.file.name) {
                fd.append('file', $scope.file, $scope.file.name);
                $http.post('/documents/attachments', fd, {
                    headers: { 'Content-Type': undefined }
                }).then(function (response) {
                    if (type === 'basis') {
                        $scope.basisFiles.push(response.data);
                        $scope.fileName = response.data.name;
                    } else if (type === 'attachment') {
                        $scope.attachments.push(response.data);
                        $scope.fileName = response.data.name;
                    }
                    usSpinnerService.stop("root");
                })
            }
        };

        StaticData.getItemsByKey("levels").then(function (levels) {
            $scope.levels = [{ name: "საფეხური" }].concat(levels);
            $scope.levelsMap = _.keyBy($scope.levels, '_id');
        });

        StaticData.getItemsByKey("faculties").then(function (faculties) {
            $scope.faculties = faculties;
            $scope.facultiesMap = _.keyBy($scope.faculties, '_id');
        });

        $scope.removeAttachment = function (type, file) {
            usSpinnerService.spin("root");
            if (type === 'basis' && !file.location) {
                for (var i in $scope.basisFiles) {
                    if (!$scope.basisFiles[i].location && file.name === $scope.basisFiles[i].name) {
                        $scope.basisFiles.splice(i, 1);
                        usSpinnerService.stop("root");
                    }
                }
            } else if (file.location) {
                DocumentsService.removeAttachment(file._id).then(function () {
                    var elementIndex;
                    if (type === 'basis') {
                        elementIndex = _.findIndex($scope.basisFiles, function (basisFile) {
                            return basisFile._id === file._id;
                        });
                        $scope.basisFiles.splice(elementIndex, 1);
                    }
                    if (type === 'attachment') {
                        elementIndex = _.findIndex($scope.attachments, function (attachmentFile) {
                            return attachmentFile._id === file._id;
                        });
                        $scope.attachments.splice(elementIndex, 1);
                    }
                    usSpinnerService.stop("root");
                })
            } else {
                usSpinnerService.stop("root");
            }
        };

    }
]);
